import { AttestationOccupations } from '../components/AttestationSection/AttestationSection.content';
import { SelectableOptionItem } from '@bonanza-social/navigation';

export const getOccupationsSelectableOptions = (): SelectableOptionItem[] => {
  return AttestationOccupations.map((str) => ({
    text: str,
  }));
};
